import React, { useEffect, useState } from "react";
import { Copy, Gift } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Referrals() {
  const [refs, setRefs] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/referrals");
      setRefs(data);
    })();
  }, []);

  const copy = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("Link copied");
  };

  return (
    <div className="p-8 md:p-12 animate-fade-up">
      <p className="eyebrow mb-2">Pillar 5 · Affiliate Engine</p>
      <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-8" data-testid="referrals-title">Referrals</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="referrals-grid">
        {refs.length === 0 && (
          <div className="bento p-12 text-center text-slate-500 lg:col-span-3">
            <Gift className="w-8 h-8 text-slate-300 mx-auto mb-3" />
            No referral links yet. Each client gets a unique link automatically.
          </div>
        )}
        {refs.map((r) => (
          <div key={r.id} className="bento p-6" data-testid={`referral-${r.unique_code}`}>
            <p className="eyebrow mb-2">Client</p>
            <h3 className="text-xl font-bold text-slate-900 mb-4">{r.client_name}</h3>
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 mb-4 flex items-center gap-2">
              <code className="text-xs flex-1 truncate font-mono">{r.public_url}</code>
              <button onClick={() => copy(r.public_url)} className="p-1.5 hover:bg-white rounded-lg" data-testid={`copy-${r.unique_code}`}>
                <Copy className="w-3.5 h-3.5" />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-slate-50 rounded-xl p-3">
                <p className="text-xs text-slate-500 mb-1">Clicks</p>
                <p className="text-2xl font-bold">{r.click_count}</p>
              </div>
              <div className="bg-emerald-50 rounded-xl p-3">
                <p className="text-xs text-emerald-700 mb-1">Conversions</p>
                <p className="text-2xl font-bold text-emerald-800">{r.conversion_count}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
